import React, { useState, useRef } from 'react';

import { createClassName } from 'utils/createClassName';
import { setCustomTimeout } from 'utils/setCustomTimeout';

import './contentLayoutStyles.scss';

type Props = {
  title: React.ReactNode;
  body: React.ReactNode;
  backAction: React.ReactNode;
  secretBody?: React.ReactNode;
};

export const ContentLayoutComponent = (props: Props) => {
  const { title, body, backAction, secretBody } = props;

  const createServiceFormLayoutClassName = createClassName('contentLayout');

  const wrapperClassName = createServiceFormLayoutClassName('wrapper');

  const titleClassName = createServiceFormLayoutClassName('title');

  const bodyClassName = createServiceFormLayoutClassName('body');

  const backActionClassName = createServiceFormLayoutClassName('backAction');

  const [isSecretBodyVisible, setIsSecretBodyVisible] = useState(false);

  const longPressTimerRef = useRef<(() => void) | null>(null);

  const startSecretBodyRevealTimeout = () => {
    longPressTimerRef.current = setCustomTimeout(() => {
      setIsSecretBodyVisible((prev) => !prev);
      longPressTimerRef.current = null;
    }, 3000);
  };

  const endSecretBodyRevealTimeout = () => {
    if (longPressTimerRef.current) {
      longPressTimerRef.current();
      longPressTimerRef.current = null;
    }
  };

  return (
    <div className={wrapperClassName}>
      <div
        className={titleClassName}
        onMouseDown={startSecretBodyRevealTimeout}
        onMouseUp={endSecretBodyRevealTimeout}
        onTouchStart={startSecretBodyRevealTimeout}
        onTouchEnd={endSecretBodyRevealTimeout}
      >
        {title}
      </div>
      <div className={bodyClassName}>
        {body}
        {isSecretBodyVisible && secretBody}
      </div>
      <div className={backActionClassName}>{backAction}</div>
    </div>
  );
};
